import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Option } from '../../types';

import i18n from '~/common/helpers/i18n';

type ProjectEntity = { name: string; description?: string };

type ProjectStoreState = {
  application: { activeRealm: string };
  project: {
    result: { project: string[] };
    entities: { project: Record<string, ProjectEntity> };
  };
};

export function useHistoryProjects() {
  const dispatch: any = useDispatch();
  const activeRealm = useSelector<ProjectStoreState, string>(
    state => state.application.activeRealm
  );
  const projectAllIds = useSelector<ProjectStoreState, string[]>(
    state => state.project.result.project
  );
  const projectById = useSelector<
    ProjectStoreState,
    Record<string, ProjectEntity>
  >(state => state.project.entities.project);

  useEffect(() => {
    dispatch.project.fetch();
  }, [activeRealm]);

  const projects: Array<Option & { description?: string }> = useMemo(
    () => [
      {
        label: i18n.t('label.all'),
        value: ''
      },
      ...projectAllIds.map(id => ({
        value: id,
        label: projectById[id]?.name,
        description: projectById[id]?.description
      }))
    ],
    [projectAllIds, projectById]
  );

  return { projects };
}
